import MailModal from './MailModal';

export default MailModal;
